export function debounce<T extends (...args: any[]) => void>(fn: T, delay: number) {
    let timeout: number;
    return (...args: Parameters<T>) => {
        clearTimeout(timeout);
        timeout = window.setTimeout(() => fn(...args), delay);
    };
}
